// OurStory.js
import React from 'react';
import { motion } from 'framer-motion';

const OurStory = () => {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-6">
              How Ivipass Began
            </h2>
          </motion.div>

          {/* Story Content */}
          <div className="space-y-6">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-base text-gray-700 font-light leading-relaxed"
            >
              Going overseas to study or to earn a living has never involved more moving parts. Applicants run into contradictory advice, sales talk dressed up as guidance, and assurances nobody is in a position to give, usually with no impartial person to ask.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-base text-gray-700 font-light leading-relaxed"
            >
              The company was set up to answer that with method rather than marketing. IMMIGRATION VISA &amp; PASSPORT SERVICES LIMITED, trading as Ivipass, was incorporated in England and Wales on 3 November 2014 and has operated on documented processes and plain explanation ever since.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-base text-gray-700 font-normal leading-relaxed"
            >
              Around eleven years on, the intention has not shifted. People should grasp what is genuinely open to them, prepare for it properly, and decide with their eyes open.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
